var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6666 101.5V34H103.333V101.5C92.4117 112.901 77.0348 120 60 120C42.9651 120 27.5883 112.901 16.6666 101.5Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6666 109.896V21.3333H93.3333V109.896C83.7993 116.278 72.3343 120 60 120C47.6656 120 36.2006 116.278 26.6666 109.896Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3333 30H34.6666V37.3333H85.3333V30ZM57.3333 43.3333H34.6666V69.3333H57.3333V43.3333ZM34.6666 74.6667H57.3333V100.667H34.6666V74.6667ZM84.6667 43.3333H62V69.3333H84.6667V43.3333Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5789 72.6667C69.8252 72.6667 69.1023 72.9652 68.5693 73.4965C68.0363 74.0279 67.7368 74.7486 67.7368 75.5V81.1667C67.7368 82.7315 66.4644 84 64.8947 84C63.3251 84 62.0526 82.7315 62.0526 81.1667V75.5C62.0526 73.2457 62.9509 71.0837 64.5499 69.4896C66.1489 67.8955 68.3176 67 70.5789 67H90.4737C92.735 67 94.9037 67.8955 96.5027 69.4896C98.1017 71.0837 99 73.2457 99 75.5V109.5C99 111.754 98.1017 113.916 96.5027 115.51C94.9037 117.104 92.735 118 90.4737 118H70.5789C68.3176 118 66.1489 117.104 64.5499 115.51C62.9509 113.916 62.0526 111.754 62.0526 109.5V103.833C62.0526 102.269 63.3251 101 64.8947 101C66.4644 101 67.7368 102.269 67.7368 103.833V109.5C67.7368 110.251 68.0363 110.972 68.5693 111.503C69.1023 112.035 69.8252 112.333 70.5789 112.333H90.4737C91.2275 112.333 91.9504 112.035 92.4834 111.503C93.0164 110.972 93.3158 110.251 93.3158 109.5V75.5C93.3158 74.7486 93.0164 74.0279 92.4834 73.4965C91.9504 72.9652 91.2275 72.6667 90.4737 72.6667H70.5789Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2535 81.9965C75.3634 80.89 77.1629 80.89 78.2728 81.9965L86.7991 90.4965C87.9091 91.603 87.9091 93.397 86.7991 94.5035L78.2728 103.003C77.1629 104.11 75.3634 104.11 74.2535 103.003C73.1436 101.897 73.1436 100.103 74.2535 98.9965L77.928 95.3333H47.8421C46.2725 95.3333 45 94.0648 45 92.5C45 90.9352 46.2725 89.6667 47.8421 89.6667H77.928L74.2535 86.0035C73.1436 84.897 73.1436 83.103 74.2535 81.9965Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/signIn.c1205c2dd80aa576391d9f6523ae988d.svg";
export { ForwardRef as ReactComponent };